module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_7042.8bd0974a.png";